import axios, { CreateAxiosDefaults } from "axios";
import { environment } from "../../utils/constants/environment";

const clientSharedValues = {
  params: {},
  withCredentials: true,
};
export const apiClient = axios.create({
  ...clientSharedValues,
  baseURL: environment.REACT_APP_Services_URL,

  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const createApiClient = (config?: CreateAxiosDefaults) => {
  return axios.create({
    ...clientSharedValues,
    baseURL: environment.REACT_APP_Services_URL,

    transformResponse: [
      function transformResponse(data) {
        return data;
      },
    ],
    ...config,
  });
};

export const publicApiClient = axios.create({
  ...clientSharedValues,
  baseURL: environment.REACT_APP_Services_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const Client = axios.create({ ...clientSharedValues });
